/* Faza size quiz. Height, weight, shape -> size -> email. Writes size_recommendation to Klaviyo.
   Config comes from snippets/fz-size-quiz.liquid as window.FZ_QUIZ. Test hooks: ?fzquiz=1 opens it, ?fzquiz=reset clears memory. */
(function () {
  'use strict';
  var C = window.FZ_QUIZ;
  if (!C || window.__fzQuiz) return;
  window.__fzQuiz = 1;
  var D = document, H = D.documentElement;
  var LANG = String(C.lang || H.lang || 'en').slice(0, 2).toLowerCase();

  var COPY = {
    en: {
      tab: 'Find your size', close: 'Close', back: '← Back', next: 'Continue →', or: 'or enter exact',
      hT: 'How tall are <em>you?</em>', hCat: ['Petite', 'Medium', 'Tall'],
      hR: { cm: ['under 163 cm', '163 – 173 cm', 'over 173 cm'], 'in': ['under 5\'4"', '5\'4" – 5\'8"', 'over 5\'8"'] },
      wT: 'And your <em>weight?</em>', wCat: ['Light', 'Medium', 'Full'],
      wR: { kg: ['under 65 kg', '65 – 85 kg', 'over 85 kg'], lbs: ['under 143 lbs', '143 – 187 lbs', 'over 187 lbs'] },
      sT: 'What\'s your <em>body shape?</em>', shape: ['Straight', 'Hourglass', 'Curvy'],
      proc: ['Mapping your fit', 'Reading your shape', 'Match found'],
      eT: '<em>We found your match.</em>', eS: 'Where should we send it? (+ a surprise for you)', ph: 'your@email.com',
      send: 'Send my match →', busy: 'Sending…',
      fine: 'By submitting, you join the Faza Club and receive your size recommendation and a welcome gift by email. Unsubscribe any time. <a href="%P">Privacy policy</a>',
      errMail: 'Please enter a valid email address.', errNet: 'That did not send. Please try once more.',
      oT: 'Journey <em>unlocked.</em>', oS: 'Check your inbox — your match is on its way.',
      j: [['Sent', 'On its<br>way to you'], ['Your store', 'Fitted.<br>Personalised.'], ['First purchase', 'Unlimited<br>confidence.']],
      tag: 'Check your inbox. <em>The rest follows.</em>'
    },
    de: {
      tab: 'Finde deine Größe', close: 'Schließen', back: '← Zurück', next: 'Weiter →', or: 'oder genau eingeben',
      hT: 'Wie groß <em>bist du?</em>', hCat: ['Petite', 'Mittel', 'Groß'],
      hR: { cm: ['unter 163 cm', '163 – 173 cm', 'über 173 cm'], 'in': ['unter 5\'4"', '5\'4" – 5\'8"', 'über 5\'8"'] },
      wT: 'Und dein <em>Gewicht?</em>', wCat: ['Leicht', 'Mittel', 'Kräftig'],
      wR: { kg: ['unter 65 kg', '65 – 85 kg', 'über 85 kg'], lbs: ['unter 143 lbs', '143 – 187 lbs', 'über 187 lbs'] },
      sT: 'Welche <em>Figur</em> hast du?', shape: ['Gerade', 'Sanduhr', 'Kurvig'],
      proc: ['Deine Passform wird berechnet', 'Deine Figur wird erfasst', 'Treffer gefunden'],
      eT: '<em>Wir haben deine Passform gefunden.</em>', eS: 'Wohin sollen wir sie schicken? (+ eine Überraschung für dich)', ph: 'deine@email.de',
      send: 'Meine Passform senden →', busy: 'Wird gesendet…',
      fine: 'Mit dem Absenden wirst du Mitglied im Faza Club und erhältst deine Größenempfehlung und ein Willkommensgeschenk per E-Mail. Abmeldung jederzeit möglich. <a href="%P">Datenschutz</a>',
      errMail: 'Bitte gib eine gültige E-Mail-Adresse ein.', errNet: 'Das hat nicht geklappt. Bitte versuche es noch einmal.',
      oT: 'Dein Weg <em>beginnt.</em>', oS: 'Schau in dein Postfach – deine Passform ist unterwegs.',
      j: [['Gesendet', 'Unterwegs<br>zu dir'], ['Dein Shop', 'Passend.<br>Persönlich.'], ['Erster Kauf', 'Zuversicht<br>ohne Grenzen.']],
      tag: 'Schau in dein Postfach. <em>Der Rest folgt.</em>'
    },
    fr: {
      tab: 'Trouve ta taille', close: 'Fermer', back: '← Retour', next: 'Continuer →', or: 'ou saisis la valeur exacte',
      hT: 'Tu mesures <em>combien ?</em>', hCat: ['Petite', 'Moyenne', 'Grande'],
      hR: { cm: ['moins de 163 cm', '163 – 173 cm', 'plus de 173 cm'], 'in': ['moins de 5\'4"', '5\'4" – 5\'8"', 'plus de 5\'8"'] },
      wT: 'Et ton <em>poids ?</em>', wCat: ['Léger', 'Moyen', 'Plus fort'],
      wR: { kg: ['moins de 65 kg', '65 – 85 kg', 'plus de 85 kg'], lbs: ['moins de 143 lbs', '143 – 187 lbs', 'plus de 187 lbs'] },
      sT: 'Quelle est ta <em>silhouette ?</em>', shape: ['Droite', 'Sablier', 'Courbes'],
      proc: ['Calcul de ta coupe', 'Lecture de ta silhouette', 'Correspondance trouvée'],
      eT: '<em>On a trouvé ta taille.</em>', eS: 'Où devons-nous l\'envoyer ? (+ une surprise pour toi)', ph: 'ton@email.fr',
      send: 'Recevoir ma taille →', busy: 'Envoi…',
      fine: 'En validant, tu rejoins le Faza Club et tu reçois ta taille recommandée et un cadeau de bienvenue par e-mail. Désinscription à tout moment. <a href="%P">Confidentialité</a>',
      errMail: 'Saisis une adresse e-mail valide.', errNet: 'L\'envoi n\'a pas abouti. Réessaie, s\'il te plaît.',
      oT: 'C\'est <em>parti.</em>', oS: 'Regarde ta boîte mail — ta taille est en route.',
      j: [['Envoyé', 'En route<br>vers toi'], ['Ta boutique', 'Ajustée.<br>Personnalisée.'], ['Premier achat', 'Confiance<br>sans limite.']],
      tag: 'Regarde ta boîte mail. <em>Le reste suit.</em>'
    },
    ar: {
      tab: 'اكتشفي مقاسك', close: 'إغلاق', back: '→ رجوع', next: 'متابعة ←', or: 'أو أدخلي القياس بدقة',
      hT: 'ما هو <em>طولكِ؟</em>', hCat: ['قصيرة', 'متوسطة', 'طويلة'],
      hR: { cm: ['أقل من 163 سم', '163 – 173 سم', 'أكثر من 173 سم'], 'in': ['أقل من 5\'4"', '5\'4" – 5\'8"', 'أكثر من 5\'8"'] },
      wT: 'وما هو <em>وزنكِ؟</em>', wCat: ['خفيف', 'متوسط', 'ممتلئ'],
      wR: { kg: ['أقل من 65 كجم', '65 – 85 كجم', 'أكثر من 85 كجم'], lbs: ['أقل من 143 رطلاً', '143 – 187 رطلاً', 'أكثر من 187 رطلاً'] },
      sT: 'ما هو <em>شكل جسمكِ؟</em>', shape: ['مستقيم', 'ساعة رملية', 'منحنٍ'],
      proc: ['نرسم مقاسكِ', 'نقرأ شكل جسمكِ', 'وجدنا ما يناسبكِ'],
      eT: '<em>وجدنا مقاسكِ.</em>', eS: 'إلى أين نرسله؟ (+ مفاجأة لكِ)', ph: 'name@email.com',
      send: 'أرسلي لي مقاسي ←', busy: 'جارٍ الإرسال…',
      fine: 'بالإرسال تنضمّين إلى نادي فازا وتصلكِ توصية المقاس وهدية الترحيب عبر البريد الإلكتروني. يمكنكِ إلغاء الاشتراك في أي وقت. <a href="%P">سياسة الخصوصية</a>',
      errMail: 'يرجى إدخال بريد إلكتروني صحيح.', errNet: 'لم يتم الإرسال. حاولي مرة أخرى.',
      oT: 'انطلقت <em>رحلتكِ.</em>', oS: 'تفقّدي بريدكِ — مقاسكِ في الطريق.',
      j: [['أُرسل', 'في طريقه<br>إليكِ'], ['متجركِ', 'مفصّل لكِ.<br>بلمسة شخصية.'], ['أول طلب', 'ثقة<br>بلا حدود.']],
      tag: 'تفقّدي بريدكِ. <em>والباقي يتبع.</em>'
    }
  };
  var T = COPY[LANG] || COPY.en;

  /* ---- memory ---- */
  var K = { done: 'fz_quiz_done', closed: 'fz_quiz_closed', tab: 'fz_quiz_tab_x', size: 'fz_size' };
  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) { } }
  function del(k) { try { localStorage.removeItem(k); } catch (e) { } }
  var q = (location.search.match(/[?&]fzquiz=([^&]+)/) || [])[1];
  if (q === 'reset') { del(K.done); del(K.closed); del(K.tab); del(K.size); }
  var force = q === '1';
  var DAY = 864e5;
  if (!force && get(K.done)) return;

  /* ---- size from height, weight, shape ----
     Faza's own chart: S = EU 36, M = 38, L = 40, XL = 42, 2XL = 44. Standard women's EU size by BMI changes at about 20 / 22 / 24.5 / 27;
     moved up half a size again (11/10, founder: 160 cm, 66 kg, BMI 25.8 is an L) because the blazers are cut oversized and the first
     version, built from the trouser waistbands, ran a size or two small. Edges 21.5 / 24 / 27 / 30. Height and weight predict a body to
     about +-1 size. Curvy (fuller hip, thigh, belly) adds 1 BMI point, so it only tips someone already close to the next letter.
     Never "XXL": the store's option value is 2XL. */
  var SIZES = ['S', 'M', 'L', 'XL', '2XL'], BMI = [21.5, 24, 27, 30], CURVY = 1;
  function size(hCm, wKg, shape) {
    var i = 0, b = wKg / Math.pow(hCm / 100, 2) + (shape === 'curvy' ? CURVY : 0);
    while (i < BMI.length && b >= BMI[i]) i++;
    return SIZES[i];
  }

  /* ---- state ---- */
  var S = { h: 168, hCm: true, w: 70, wKg: true, shape: 'hourglass', pickedH: false, pickedW: false };
  var HV = [158, 168, 177], WV = [57, 75, 92];

  /* ---- markup ---- */
  function el(tag, id, html, cls) { var e = D.createElement(tag); if (id) e.id = id; if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  var tab = el('div', 'fzq-tab', '<button class="x" type="button" aria-label="' + T.close + '">×</button><button class="t" type="button">' + T.tab + '</button>');
  var root = el('div', 'fzq', null);
  root.setAttribute('role', 'dialog'); root.setAttribute('aria-label', T.tab);
  function dots(n) { var s = '<div class="dots">'; for (var i = 1; i <= 4; i++) s += '<i class="dot ' + (i < n ? 'done' : i === n ? 'on' : '') + '"></i>'; return s + '</div>'; }
  function pills(prefix, names, ranges) {
    var s = '<div class="pills">';
    for (var i = 0; i < 3; i++) s += '<button type="button" class="pill" data-' + prefix + '="' + i + '">' + names[i] + '<small data-r="' + i + '">' + ranges[i] + '</small></button>';
    return s + '</div>';
  }
  function stepper(f) {
    return '<div class="stepper"><button type="button" data-adj="' + f + '" data-d="-1" aria-label="−">−</button><div class="v"><span class="n" data-num="' + f + '"></span><span class="u" data-unit="' + f + '"></span></div><button type="button" data-adj="' + f + '" data-d="1" aria-label="+">+</button></div>';
  }
  function exact(f, a, b) {
    return '<div class="exact"><span class="or">' + T.or + '</span><span class="units"><button type="button" data-u="' + f + ':' + a + '">' + a + '</button><button type="button" data-u="' + f + ':' + b + '">' + b + '</button></span></div>' + stepper(f);
  }
  var P = (C.policy || '/policies/privacy-policy');
  var SHAPES = ['straight', 'hourglass', 'curvy'], tiles = '';
  for (var si = 0; si < 3; si++) tiles += '<button type="button" class="shape" data-shape="' + SHAPES[si] + '"><img src="' + (C.img && C.img[SHAPES[si]] || '') + '" alt="" width="240" height="320"><span>' + T.shape[si] + '</span></button>';
  var jIcons = [
    '<span class="fly"><svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M1 1.5L12 6.5L1 11.5V7.8L8.5 6.5L1 5.2V1.5Z" stroke="currentColor" stroke-width="1.2" stroke-linejoin="round" stroke-linecap="round"/></svg></span>',
    '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2 2h1.5l1 5h5l1-3.5H4.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="5.5" cy="9.5" r="1" stroke="currentColor" stroke-width="1.1"/><circle cx="9" cy="9.5" r="1" stroke="currentColor" stroke-width="1.1"/></svg>',
    '<svg width="13" height="10" viewBox="0 0 13 10" fill="none"><rect x=".75" y=".75" width="11.5" height="8.5" rx="1.5" stroke="currentColor" stroke-width="1.2"/><path d="M.75 3.5h11.5" stroke="currentColor" stroke-width="1.2"/><rect x="2.5" y="5.5" width="3" height="1.5" rx=".5" fill="currentColor"/></svg>'
  ];
  var journey = '<div class="journey">';
  for (var ji = 0; ji < 3; ji++) journey += '<div class="js ' + (ji === 0 ? 'done' : ji === 1 ? 'next' : '') + '"><div class="jb">' + jIcons[ji] + '</div><div class="jn">' + T.j[ji][0] + '</div><div class="jd">' + T.j[ji][1] + '</div></div>';
  journey += '</div>';

  root.innerHTML = '<div class="card"><button class="x" type="button" aria-label="' + T.close + '">×</button>' +
    '<div class="panel" data-p="1">' + dots(1) + '<h2 class="title">' + T.hT + '</h2>' + pills('hc', T.hCat, T.hR.cm) + exact('h', 'cm', 'in') + '<button class="cta" type="button" data-go="2">' + T.next + '</button></div>' +
    '<div class="panel" data-p="2">' + dots(2) + '<button class="back" type="button" data-go="1">' + T.back + '</button><h2 class="title">' + T.wT + '</h2>' + pills('wc', T.wCat, T.wR.kg) + exact('w', 'kg', 'lbs') + '<button class="cta" type="button" data-go="3">' + T.next + '</button></div>' +
    '<div class="panel" data-p="3">' + dots(3) + '<button class="back" type="button" data-go="2">' + T.back + '</button><h2 class="title">' + T.sT + '</h2><div class="shapes">' + tiles + '</div><button class="cta" type="button" data-go="proc">' + T.next + '</button></div>' +
    '<div class="panel" data-p="proc"><div class="proc"><div class="bar"><i></i></div><div aria-live="polite">' +
      '<div class="ps"><span class="pd"></span><span class="pt">' + T.proc[0] + '</span></div>' +
      '<div class="ps" style="margin-top:16px"><span class="pd"></span><span class="pt">' + T.proc[1] + '</span></div>' +
      '<div class="ps" style="margin-top:16px"><span class="pd"></span><span class="pt">' + T.proc[2] + '</span></div></div></div></div>' +
    '<div class="panel" data-p="4">' + dots(4) + '<button class="back" type="button" data-go="3">' + T.back + '</button><div><h2 class="title">' + T.eT + '</h2><p class="sub">' + T.eS + '</p></div>' +
      '<form novalidate><input class="field" type="email" name="email" inputmode="email" autocomplete="email" placeholder="' + T.ph + '" aria-label="' + T.ph + '" required>' +
      '<div class="err" aria-live="polite"></div><button class="cta" type="submit">' + T.send + '</button></form>' +
      '<p class="fine">' + T.fine.replace('%P', P) + '</p></div>' +
    '<div class="panel" data-p="5"><div><h2 class="title">' + T.oT + '</h2><p class="sub">' + T.oS + '</p></div>' + journey + '<p class="tag">' + T.tag + '</p></div></div>';

  /* ---- ui ---- */
  function $(s, r) { return (r || root).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); }
  function show(n) { $$('.panel').forEach(function (p) { p.classList.toggle('show', p.getAttribute('data-p') === String(n)); }); }
  function paintH() {
    $('[data-num=h]').textContent = S.h; $('[data-unit=h]').textContent = S.hCm ? 'cm' : 'in';
    var r = T.hR[S.hCm ? 'cm' : 'in']; $$('.panel[data-p="1"] small').forEach(function (s, i) { s.textContent = r[i]; });
    $$('[data-u^="h:"]').forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-u') === 'h:' + (S.hCm ? 'cm' : 'in')); });
    $$('[data-hc]').forEach(function (b) { b.classList.toggle('on', S.pickedH === +b.getAttribute('data-hc') + 1); });
  }
  function paintW() {
    $('[data-num=w]').textContent = S.w; $('[data-unit=w]').textContent = S.wKg ? 'kg' : 'lbs';
    var r = T.wR[S.wKg ? 'kg' : 'lbs']; $$('.panel[data-p="2"] small').forEach(function (s, i) { s.textContent = r[i]; });
    $$('[data-u^="w:"]').forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-u') === 'w:' + (S.wKg ? 'kg' : 'lbs')); });
    $$('[data-wc]').forEach(function (b) { b.classList.toggle('on', S.pickedW === +b.getAttribute('data-wc') + 1); });
  }
  function paintShape() { $$('[data-shape]').forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-shape') === S.shape); }); }
  function toCm() { return S.hCm ? S.h : Math.round(S.h * 2.54); }
  function toKg() { return S.wKg ? S.w : Math.round(S.w / 2.205); }

  var timers = [];
  function clearTimers() { timers.forEach(clearTimeout); timers = []; }
  function later(f, ms) { timers.push(setTimeout(f, ms)); }
  function runProc() {
    show('proc');
    var ps = $$('.ps'), bar = $('.bar i');
    ps.forEach(function (p) { p.className = 'ps'; }); bar.style.transition = 'none'; bar.style.width = '0';
    later(function () { bar.style.transition = ''; bar.style.width = '100%'; ps[0].className = 'ps active'; }, 40);
    later(function () { ps[0].className = 'ps done'; ps[1].className = 'ps active'; }, 1400);
    later(function () { ps[1].className = 'ps done'; ps[2].className = 'ps found'; }, 3600);
    later(function () { show(4); var f = $('.field'); if (f) f.focus(); }, 4500);
  }

  /* the cookie banner sits at the bottom: keep the pop-up and the folded tab clear of it */
  function lift() {
    var b = D.getElementById('shopify-pc__banner'), h = 0;
    if (b && b.offsetHeight && getComputedStyle(b).display !== 'none') h = b.offsetHeight;
    H.style.setProperty('--fzq-b', h + 'px');
  }
  setInterval(lift, 1500); window.addEventListener('resize', lift);

  var lastFocus = null;
  function open() {
    lastFocus = D.activeElement; lift();
    tab.classList.remove('on'); root.classList.remove('closing'); root.classList.add('open'); show(1); paintH(); paintW(); paintShape();
    set('fz_quiz_seen', '1');
  }
  function close() {
    clearTimers(); set(K.closed, String(Date.now())); lift();
    root.classList.add('closing');
    setTimeout(function () {
      root.classList.remove('open', 'closing');
      if (!get(K.done)) tab.classList.add('on');
    }, 230);
    if (lastFocus && lastFocus.focus) try { lastFocus.focus(); } catch (e) { }
  }

  /* ---- submit: Klaviyo list subscribe (form-encoded, no preflight). Same call the scratch pop-up uses. ---- */
  function submit(email, done, fail) {
    var sz = size(toCm(), toKg(), S.shape);
    var f = { size_recommendation: sz, quiz_height_cm: toCm(), quiz_weight_kg: toKg(), quiz_body_shape: S.shape, quiz_locale: LANG, signup_source: 'size-quiz' };
    var body = 'g=' + encodeURIComponent(C.list) + '&email=' + encodeURIComponent(email) + '&$fields=' + Object.keys(f).join(',');
    Object.keys(f).forEach(function (k) { body += '&' + k + '=' + encodeURIComponent(f[k]); });
    fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body })
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j.success) done(sz); else fail(); })
      .catch(fail);
  }

  /* ---- events ---- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    var b = t.closest ? t.closest('button') : null; if (!b) return;
    if (b.classList.contains('x')) return close();
    var g = b.getAttribute('data-go');
    if (g === 'proc') return runProc();
    if (g) { clearTimers(); return show(g); }
    var a = b.getAttribute('data-adj');
    if (a) {
      var d = +b.getAttribute('data-d');
      if (a === 'h') { var lo = S.hCm ? 140 : 55, hi = S.hCm ? 210 : 83; S.h = Math.max(lo, Math.min(hi, S.h + d)); S.pickedH = false; paintH(); }
      else { var l2 = S.wKg ? 40 : 88, h2 = S.wKg ? 150 : 330; S.w = Math.max(l2, Math.min(h2, S.w + d)); S.pickedW = false; paintW(); }
      return;
    }
    var u = b.getAttribute('data-u');
    if (u) {
      var p = u.split(':');
      if (p[0] === 'h') { var c = p[1] === 'cm'; if (c !== S.hCm) { S.h = c ? Math.round(S.h * 2.54) : Math.round(S.h / 2.54); S.hCm = c; paintH(); } }
      else { var k = p[1] === 'kg'; if (k !== S.wKg) { S.w = k ? Math.round(S.w / 2.205) : Math.round(S.w * 2.205); S.wKg = k; paintW(); } }
      return;
    }
    var hc = b.getAttribute('data-hc');
    if (hc != null) { S.h = S.hCm ? HV[+hc] : Math.round(HV[+hc] / 2.54); S.pickedH = +hc + 1; return paintH(); }
    var wc = b.getAttribute('data-wc');
    if (wc != null) { S.w = S.wKg ? WV[+wc] : Math.round(WV[+wc] * 2.205); S.pickedW = +wc + 1; return paintW(); }
    var sh = b.getAttribute('data-shape');
    if (sh) { S.shape = sh; paintShape(); }
  });
  $('form').addEventListener('submit', function (e) {
    e.preventDefault();
    var inp = $('.field'), err = $('.err'), btn = $('form .cta'), em = (inp.value || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em)) { err.textContent = T.errMail; inp.focus(); return; }
    err.textContent = ''; btn.disabled = true; btn.textContent = T.busy;
    submit(em, function (sz) {
      set(K.done, '1'); set(K.size, sz); tab.classList.remove('on'); show(5);
      try { D.dispatchEvent(new CustomEvent('fzquiz:done', { detail: { size: sz } })); } catch (x) { }
    }, function () { err.textContent = T.errNet; btn.disabled = false; btn.textContent = T.send; });
  });
  D.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('open')) close(); });
  $('.t', tab).addEventListener('click', open);
  $('.x', tab).addEventListener('click', function () { tab.classList.remove('on'); set(K.tab, String(Date.now())); });

  /* ---- boot: folded tab after 4s, card after 15s, card once a day. Waits for the geo banner. ---- */
  function boot() {
    D.body.appendChild(tab); D.body.appendChild(root); lift();
    var tabX = +get(K.tab) || 0, closed = +get(K.closed) || 0, now = Date.now();
    if (force) { open(); return; }
    if (now - tabX > 7 * DAY) setTimeout(function () { if (!root.classList.contains('open') && !get(K.done)) tab.classList.add('on'); }, 4000);
    if (now - closed > DAY) {
      var fired = false, tries = 0;
      (function go() {
        setTimeout(function () {
          var geo = D.getElementById('fzgeo');
          if (geo && !geo.hidden && tries++ < 10) return go();
          if (!fired && !get(K.done)) { fired = true; open(); }
        }, tries ? 3000 : 15000);
      })();
    }
  }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
})();
